import React, {useState} from 'react';
import db from '../firebase/firebaseConfig'
import { collection, addDoc, doc, onSnapshot } from "firebase/firestore";
import {Boton2, Formulario, ContenidoFormulario, Input} from './css/estilos'
import 'bootstrap/dist/css/bootstrap.min.css';



const FormularioChat = () => {
    
    const [mensaje, cambiarMensaje] = useState('');

// Funcion asincrona. Cuando tocamos en el boton agregar. Ejecuta y nos indica cuando termino de enviar a la base de datos.
// async y await para que espere a que termine el addDoc y luego seguir con lo demas.
// try - catch es para atrapar errores

    const onSubmit = async (e) => {
    e.preventDefault();

    if (mensaje == "") {
        alert("Debes escribir un mensaje!!")
    } else {
        try {
            await addDoc(collection(db, 'datos-1'),  // Agregamos con addDoc, La info a los documentos de Firebase. Usando el comando collection con 2 parametros. db = base de datos y usuarios = el nombre de la coleccion. Donde nombre y correo son los value de los input.
                {
                mensaje: mensaje,
            });
            } catch (error) {
                console.log(error);
            }
    }
    cambiarMensaje(''); // Los deja en blanco luego de enviar
    }
    return ( 
        <ContenidoFormulario>
        <Formulario action="" onSubmit={onSubmit}>
            <div className="col-12">
            <Input
                type="text"
                name="mensaje"
                value={mensaje}
                onChange={(e) => cambiarMensaje(e.target.value)}
                placeholder="Escribe tu mensaje"
            />
            </div>          
            <Boton2 type="submit">Agregar</Boton2>
        </Formulario>
        </ContenidoFormulario>
        );
}
 
export default FormularioChat;